module.exports = __webpack_public_path__ + "static/media/sy.64f0d2d7.svg";